module.exports = __webpack_public_path__ + "img/room.67cf496b.svg";